import React from "react";
import { motion } from "framer-motion";
import '../../assets/css/KeralaPackage.css'

const images = [
  "https://images.unsplash.com/photo-1506744038136-46273834b3fb",
  "https://images.unsplash.com/photo-1524492412937-b28074a5d7da",
  "https://images.unsplash.com/photo-1500375592092-40eb2168fd21",
  "https://images.unsplash.com/photo-1501785888041-af3ef285b470",
  "https://images.unsplash.com/photo-1493558103817-58b2924bce98",
  "https://images.unsplash.com/photo-1469474968028-56623f02e42e",
];

export default function KeralaPackage() {
  return (
    <section className="keralaWrap">

      <motion.div
        className="keralaCard"
        initial={{ opacity: 0, y: 60 }}
        whileInView={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7 }}
        whileHover={{ scale: 1.02 }}
      >

        {/* LEFT IMAGE STACK */}
        <div className="keralaImages">
          {images.map((img, i) => (
            <motion.div
              key={i}
              className={`imgTile tile${i}`}
              initial={{ opacity: 0, scale: 0.8 }}
              whileInView={{ opacity: 1, scale: 1 }}
              transition={{ delay: i * 0.1 }}
              whileHover={{ scale: 1.08, rotate: 1 }}
            >
              <img src={img} alt="Kerala" />
            </motion.div>
          ))}
        </div>

        {/* RIGHT CONTENT */}
        <motion.div
          className="keralaContent"
          initial={{ opacity: 0, x: 40 }}
          whileInView={{ opacity: 1, x: 0 }}
        >

          <h2>Kerala Backwater Package</h2>

          <p className="duration">Duration: 4 Days / 3 Nights</p>

          <div className="includes">
            <h4>Includes:</h4>
            <ul>
              <li>Houseboat Stay</li>
              <li>Sightseeing</li>
              <li>Meals Included</li>
              <li>Nature Tours</li>
            </ul>
          </div>

          <p className="note">
            Best for family & honeymoon
          </p>

          {/* 🔥 BUTTON ADDED */}
          <motion.a
            href="tel:+91 9699581519"
            className="callBtnKerala"
            whileHover={{ scale: 1.08 }}
            whileTap={{ scale: 0.95 }}
          >
            📞 Call to Get Offers
          </motion.a>

        </motion.div>

      </motion.div>

    </section>
  );
}